import type {
  AnalyticsSalesByDayOfWeek,
  AnalyticsSalesByMonth,
} from "@/@types/Analytics";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { SalesBarChartCard } from "./SalesBarChartCard";

interface SalesByPeriodChartsProps {
  salesByDayOfWeek?: AnalyticsSalesByDayOfWeek[];
  salesByMonth?: AnalyticsSalesByMonth[];
  isLoading: boolean;
}

export function SalesByPeriodCharts({
  salesByDayOfWeek,
  salesByMonth,
  isLoading,
}: SalesByPeriodChartsProps) {
  const { t } = useTranslation("reports");

  const dayOfWeekData = useMemo(
    () =>
      salesByDayOfWeek?.map((item) => ({
        name: t(`reports:days_of_week.${item.day}`),
        vendas: item.count,
        amount_formatted: item.amount_formatted,
      })) ?? [],
    [salesByDayOfWeek, t],
  );

  const monthData = useMemo(
    () =>
      salesByMonth?.map((item) => ({
        name: `${t(`reports:months.${item.month}`)}/${item.year}`,
        vendas: item.count,
        amount_formatted: item.amount_formatted,
      })) ?? [],
    [salesByMonth, t],
  );

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
      <SalesBarChartCard
        title={t("reports:chart_sales_by_day")}
        description={t("reports:chart_sales_by_day_desc")}
        data={dayOfWeekData}
        isLoading={isLoading}
        mobileHeight={200}
        desktopHeight={250}
        heightClassName="h-[200px] sm:h-[250px]"
      />
      <SalesBarChartCard
        title={t("reports:chart_sales_by_month")}
        description={t("reports:chart_sales_by_month_desc")}
        data={monthData}
        isLoading={isLoading}
        mobileHeight={200}
        desktopHeight={250}
        heightClassName="h-[200px] sm:h-[250px]"
      />
    </div>
  );
}
